<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="auto">
          <h6 class="m-0">Informações do serviço</h6>
        </d-col>
      </d-row>
    </d-card-header>

     <d-card-body class="d-flex flex-column" v-if="model.service">
      <no-permission v-if="isCustomer" />
      <template v-else>
        <d-form @submit="save" class="d-flex flex-fill flex-column">
          <d-form-row>
            <!-- Quotation type -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Tipo de projeto</label>
              <d-select v-model="model.type_id" :state="hasErrorFiled('type_id')">
                <option :value="option.id" v-for="(option, index) in typeOptions" :key="index">{{ option.name }}</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de projeto é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Table price -->
            <d-col cols="12" md="2" class="form-group">
              <label for="name">Tabela de preço</label>
              <d-select
                v-model="model.service.price_table"
              >
                <option
                  v-for="type in priceTables"
                  :key="type.id"
                  :value="type.slug"
                >
                  {{ type.name }}
                </option>
              </d-select>
            </d-col>
            <!-- Quotation class -->
            <d-col cols="12" md="2" class="form-group ">
              <label for="name">Tipo de classe</label>
              <d-select v-model="model.class_id" :state="hasErrorFiled('class_id')">
                <option :value="option.id" v-for="(option, index) in classOptions" :key="index">{{ option.name }}</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de classe é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Service type -->
            <d-col cols="12" md="2" class="form-group ">
              <label for="name">Tipo de serviço</label>
              <d-select
                v-model="model.service.service_type"
                :state="hasErrorFiled('service_type')"
                :options="serviceTypes"
                text-field="name"
                value-field="value"
              ></d-select>
              <d-form-invalid-feedback>Tipo de serviço é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Segment -->
            <d-col cols="12" md="2" class="form-group ">
              <label for="name">Segmento</label>
              <d-select
                class="form-control"
                v-model="model.drive_id"
                :state="hasErrorFiled('drive_id')"
                text-field="name"
                value-field="id"
                :options="drives"
              ></d-select>
              <d-form-invalid-feedback>Segmento é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Classification -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Classificação</label>
              <input-star :model.sync="model.service.rating" :state="hasErrorFiled('rating')" :max-rating='5' :starSize='30'/>
              <d-form-invalid-feedback>Classificação é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Terrain Type -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Tipo de terreno</label>
              <d-select
                v-model="model.service.terrain_type"
                :options="groundTypes"
                text-field="name"
                value-field="value"
              ></d-select>
            </d-col>
            <!-- Project Size -->
            <ProjectMeasure :model="model" />

            <!-- Goal -->
            <d-col cols="12" md="3" class="form-group ">
              <label for="name">Previsão de instalação</label>
              <datepicker :model.sync="model.service.installation_date"/>
            </d-col>
            <!-- Concorrentes -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Concorrentes</label>
              <d-select
                v-model="model.service.has_competitor"
              >
                <option value="sim">Sim</option>
                <option value="não">Não</option>
              </d-select>
            </d-col>
          </d-form-row>
        </d-form>
      </template>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button class="btn btn-success" @click="save">Salvar e avançar</button>
        </d-col>
      </d-form-row>
      <import-modals/>
    </d-card-body>

  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep, getDateTimeISO } from '_utils';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinValidateForm from '_common/mixins/ValidateForm';
import InputStar from '_shared/InputStar.vue';
import NoPermission from './NoPermission.vue';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import ProjectMeasure from './ProjectMeasure.vue';
import { MODEL, SERVICE, TYPE_OPTIONS, CLASS_OPTIONS, _LOAD_MODEL_, _OPEN_CONFIRMATION_, _CANCEL_PRICE_TABLE_CHANGE_ } from './QuotationModel';

export default {
  name: 'Step-service',
  mixins: [MixinValidateForm],
  data() {
    return {
      model: cloneDeep(MODEL),
      oldPriceTable: null,
      errors: {
        service_type: { required: false },
        drive_id: { required: false },
        type_id: { required: false },
        rating: { required: false },
      },
    };
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    typeOptions() {
      const { typeOptions } = this.$store.state.quotation;
      if (typeOptions && typeOptions.length) {
        return typeOptions;
      }
      return TYPE_OPTIONS;
    },
    classOptions() {
      const { classOptions } = this.$store.state.quotation;
      if (classOptions && classOptions.length) {
        return classOptions;
      }
      return CLASS_OPTIONS;
    },
    drives() {
      const { drives } = this.$store.state.quotation;
      if (drives && drives.length) {
        return drives;
      }
      return [];
    },
    canUpdatePrices() {
      const { quotation } = this.$store.state.quotation;

      if (!quotation || !quotation.steps) return false;

      const steps = quotation.steps.step;
      const requiredCompleted = steps.service?.completed === true && steps.quotation?.completed === true;

      return requiredCompleted;
    },
    serviceTypes() {
      return [
        { value: 'Nova instalação', name: 'Nova instalação' },
        { value: 'Fornecimento', name: 'Fornecimento' },
        { value: 'Manutenção', name: 'Manutenção' },
        { value: 'Troca', name: 'Troca' },
      ];
    },
    finalities() {
      return [
        { value: 'Área de piscina', name: 'Área de piscina' },
        { value: 'Área Pet', name: 'Área Pet' },
        { value: 'Beach Tenis', name: 'Beach Tenis' },
        { value: 'Campo de Futebol - CT', name: 'Campo de Futebol - CT' },
        { value: 'Estadio', name: 'Estadio' },
        { value: 'Futebol Society', name: 'Futebol Society' },
        { value: 'Jardim', name: 'Jardim' },
        { value: 'Playground', name: 'Playground' },
        { value: 'Poliesportivo', name: 'Poliesportivo' },
        { value: 'Quadra de Pedal', name: 'Quadra de Pedal' },
        { value: 'Quadra de Tenis', name: 'Quadra de Tenis' },
        { value: 'Quintal', name: 'Quintal' },
        { value: 'Rudge', name: 'Rudge' },
        { value: 'Varanda', name: 'Varanda' },
        { value: 'Outros', name: 'Outros' },
      ];
    },
    groundTypes() {
      return [
        { value: 'Grama natural', name: 'Grama natural' },
        { value: 'Ceramico', name: 'Ceramico' },
        { value: 'Cimento', name: 'Cimento' },
        { value: 'Contra piso', name: 'Contra piso' },
        { value: 'Nenhum', name: 'Nenhum' },
        { value: 'Pedra', name: 'Pedra' },
        { value: 'Sem terreno', name: 'Sem terreno' },
        { value: 'Terra', name: 'Terra' },
      ];
    },
    priceTables() {
      const { priceTableNames } = this.$store.state.product;
      if (priceTableNames && priceTableNames.list.length) {
        return priceTableNames.list;
      }
      return [];
    },
  },
  components: {
    InputStar,
    Datepicker,
    NoPermission,
    ImportModals,
    ProjectMeasure,
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getDrives',
      'getTypeOptions',
      'getClassOptions',
      'getPriceTableNames',
    ]),
    save() {
      if (this.checkServiceForm()) {
        this.model.service.quotation_id = this.model.id;
        this.model.service.quotation_id = this.model.id;
        this.model.service.project_width = parseFloat(this.model.service.project_width);
        this.model.service.project_length = parseFloat(this.model.service.project_length);
        this.model.service.installation_date = getDateTimeISO(this.model.service.installation_date);
        this.model.step = 'service';
        QuotationService.updateQuotation(this.model)
          .then(response => {
            this.$store.commit('setQuotation', response);
            Events.$emit(_LOAD_MODEL_, response);
            this.$router.push({ name: 'admin-quotation-edit', params: { quotationId: response.id } });
          });
      }
    },
    checkServiceForm() {
      this.submitted = true;
      let valid = true;
      ['drive_id', 'type_id'].forEach(field => {
        this.errors[field].required = false;
        if (!this.model[field] && this.errors[field]) {
          this.errors[field].required = true;
          valid = false;
        }
      });
      Object.keys(this.model.service).forEach(field => {
        if (this.errors[field]) {
          this.errors[field].required = false;
          if (!this.model.service[field]) {
            this.errors[field].required = true;
            valid = false;
          }
        }
      });
      return valid;
    },
    getOptions() {
      if (!this.$store.state.quotation.typeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.quotation.classOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getClassOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.quotation.drives) {
        this.setToggle({ type: 'progress', bool: true });
        this.getDrives()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    loadModel(quotation) {
      if (quotation) {
        this.model = quotation;
      }
      if (!this.model.service) {
        this.model.service = cloneDeep(SERVICE);
      }
    },
  },
  watch: {
    'model.service.price_table'(newVal, oldVal) {
      const isSameValue = newVal === oldVal;
      const isRevertedValue = newVal === this.oldPriceTable;

      const shouldIgnoreChange = isSameValue || isRevertedValue || !this.canUpdatePrices;
      if (shouldIgnoreChange) return;

      this.oldPriceTable = oldVal;

      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_OPEN_CONFIRMATION_, { quotation: this.model, type: 'approvedPriceTable' });
    },
  },
  mounted() {
    this.getPriceTableNames({
      search: '',
      skip: 0,
      take: 10,
      page: 1,
    });
    this.getOptions();
    const { quotation } = this.$store.state.quotation;
    this.oldPriceTable = quotation?.service?.price_table || null;
    this.loadModel(quotation);
    Events.$on(_LOAD_MODEL_, model => {
      this.loadModel(model);
    });
    Events.$on(_CANCEL_PRICE_TABLE_CHANGE_, () => {
      this.model.service.price_table = this.oldPriceTable;
    });
  },
};
</script>
